<script>
</script>
<div class="flex justify-center pb-20">
    <span
        on:click={() => {location.href="https://wa.me/256770762326?text='Hello I would like to book a session.'"}}
        on:keypress
        class="btnBg text-center  min-[280px]:px-3 min-[280px]:py-2 min-[280px]:text-md   min-[320px]:px-5  min-[320px]:py-4 text-white min-[320px]:text-xl rounded hover:shadow-lg hover:bg-blue-800"
        >Book a session with a professional</span
    >
</div>

<style>
    .btnBg {
        background-color: #3d0cd6;
    }
    .btnBg:hover {
        background-color: #39F179;
        color: black;
    }
</style>
